(function () {
  var STORAGE_KEY = 'batavia_theme_cohort';
  var CART_ATTRIBUTE_KEY = 'theme_cohort';
  var COHORT_VALUE = 'new_theme';

  function getStoredCohort() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (error) {
      return null;
    }
  }

  function setStoredCohort(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (error) {
      // Ignore storage failures (private mode, strict browser settings).
    }
  }

  function getCartUpdateUrl() {
    if (window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.cart_update_url) {
      return window.FoxTheme.routes.cart_update_url;
    }

    return '/cart/update.js';
  }

  function getFetchConfig(body) {
    if (window.FoxTheme && window.FoxTheme.utils && typeof window.FoxTheme.utils.fetchConfig === 'function') {
      var config = window.FoxTheme.utils.fetchConfig();
      return Object.assign({}, config, { body: body, keepalive: true });
    }

    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: body,
      keepalive: true
    };
  }

  function syncThemeAttributionToCart(cohort) {
    if (!cohort) return;

    var requestBody = JSON.stringify({
      attributes: { [CART_ATTRIBUTE_KEY]: cohort }
    });

    fetch(getCartUpdateUrl(), getFetchConfig(requestBody)).catch(function () {
      // Silent fail: attribution should never block shopper actions.
    });
  }

  var currentCohort = getStoredCohort();
  if (currentCohort !== COHORT_VALUE) {
    setStoredCohort(COHORT_VALUE);
    currentCohort = COHORT_VALUE;
  }

  syncThemeAttributionToCart(currentCohort);
})();
